import { ModalService } from '@app/plugins/iview-modal-modify/service';
import i18n from '@app/plugins/i18n';
import { MediaService } from '@pbx/services/MediaService';
import AddMedia from '@pbx/components/media/modals/add-media';

class MediaModalService extends ModalService {
  constructor() {
    super(MediaService);
  }

  remove(id, item) {
    return this.$removeItem(id, item, {
      content: i18n.t('pbx.media.modal.remove.content', {
        description: `<strong>${item.description}</strong>`
      })
    });
  }

  add_media() {
    return this.$open({
      title: i18n.t('pbx.media.list.add_media'),
      width: this.size.confirm,
      render: h =>
        h(AddMedia, {
          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new MediaModalService();
export { instance as MediaModalService };
